// Streaming-Download ueber den Helfer unter /herunterladen/ (public/herunterladen/sw.js).
// Die Datei wird hier Block fuer Block entschluesselt und an den Helfer gereicht, der sie als
// normalen Download an den Browser gibt. So liegt nie die ganze Datei im Arbeitsspeicher, es braucht
// keinen Speichern-Dialog, und es geht auch im eingebetteten Tab und in Firefox.

const SCOPE = '/herunterladen/';
let registrierung = null;

/** Safari gibt Downloads aus einem Service Worker nicht zuverlaessig weiter, dort bleibt der alte Weg. */
export function streamDownloadSupported() {
  if (typeof window === 'undefined' || !window.isSecureContext) return false;
  if (!('serviceWorker' in navigator) || typeof ReadableStream !== 'function' || typeof MessageChannel !== 'function') return false;
  const ua = navigator.userAgent || '';
  const istSafari = /Safari\//.test(ua) && !/Chrome\/|Chromium\/|CriOS\/|Edg\/|Firefox\/|FxiOS\//.test(ua);
  return !istSafari;
}

function aktiv(reg) {
  if (reg.active) return Promise.resolve(reg.active);
  const w = reg.installing || reg.waiting;
  return new Promise((resolve, reject) => {
    if (!w) { reject(new Error('sw_missing')); return; }
    const t = setTimeout(() => reject(new Error('sw_timeout')), 10000);
    w.addEventListener('statechange', () => {
      if (w.state === 'activated') { clearTimeout(t); resolve(reg.active || w); }
      if (w.state === 'redundant') { clearTimeout(t); reject(new Error('sw_redundant')); }
    });
  });
}

/** Helfer vorab anmelden (nach dem Entsperren), damit der Download sofort startet. */
export function prepareStreamDownload() {
  if (!registrierung) {
    registrierung = navigator.serviceWorker.register(`${SCOPE}sw.js`, { scope: SCOPE })
      .then(aktiv)
      .catch((e) => { registrierung = null; throw e; });
  }
  return registrierung;
}

function zufallsId() {
  const b = crypto.getRandomValues(new Uint8Array(16));
  return Array.from(b, (x) => x.toString(16).padStart(2, '0')).join('');
}

/**
 * Laedt `bloecke` (async Iterator von Uint8Array, Klartext in Reihenfolge) als Datei `name` herunter.
 * Resolved, wenn der letzte Block uebergeben ist.
 */
export async function streamToDownload({ name, size, bloecke }) {
  const sw = await prepareStreamDownload();
  const id = zufallsId();
  const kanal = new MessageChannel();
  const port = kanal.port1;
  const it = bloecke[Symbol.asyncIterator]();
  let rahmen = null;
  let ping = null;
  let fertig = false;
  return new Promise((resolve, reject) => {
    const aufraeumen = () => {
      fertig = true;
      clearInterval(ping);
      clearTimeout(startFrist);
      // Den Rahmen etwas spaeter entfernen: der Browser hat den Download dann sicher uebernommen.
      setTimeout(() => { if (rahmen) rahmen.remove(); port.close(); }, 5000);
    };
    const scheitern = (err) => {
      if (fertig) return;
      try { port.postMessage({ type: 'fehler', fehler: err?.message || 'fehler' }); } catch (_) { /* Kanal zu */ }
      try { it.return?.(); } catch (_) { /* egal */ }
      aufraeumen();
      reject(err);
    };
    // Holt der Browser den Download nicht ab (z. B. blockiert), nicht ewig warten.
    const startFrist = setTimeout(() => scheitern(new Error('STREAM_NOT_STARTED')), 30000);
    port.onmessage = async ({ data }) => {
      if (fertig || !data) return;
      if (data.type === 'bereit') {
        rahmen = document.createElement('iframe');
        rahmen.hidden = true;
        rahmen.title = 'Download';
        rahmen.src = `${SCOPE}${id}`;
        document.body.appendChild(rahmen);
        ping = setInterval(() => { try { sw.postMessage({ type: 'ping' }); } catch (_) { /* weg */ } }, 20000);
        return;
      }
      if (data.type === 'abbruch') { scheitern(Object.assign(new Error('Download abgebrochen.'), { code: 'ABORTED' })); return; }
      if (data.type !== 'weiter') return;
      clearTimeout(startFrist);
      try {
        const { value, done } = await it.next();
        if (done) {
          port.postMessage({ type: 'fertig' });
          aufraeumen();
          resolve();
          return;
        }
        const buf = value.byteOffset === 0 && value.byteLength === value.buffer.byteLength
          ? value.buffer
          : value.slice().buffer;
        port.postMessage({ type: 'block', block: buf }, [buf]);
      } catch (err) {
        scheitern(err);
      }
    };
    sw.postMessage({ type: 'start', id, name, size }, [kanal.port2]);
  });
}
